import React from "react";
import "./OwCheckbox.scss";
import { FormattedMessage } from "react-intl";
import * as _ from "lodash-es";
import ISupplierModel from "../../../models/ISupplierModel";
import IOwCheckboxProps from "./IOwCheckboxProps";

type Props = IOwCheckboxProps & {
    label?: string;
    description?: string;
    skipTranslate?: boolean;
    className?: string;
    labelClassName?: string;
    fn: (e: React.ChangeEvent<HTMLInputElement>) => void;
    disabled?: boolean;
    checked?: boolean;
    name?: string;
    ref?: React.RefObject<HTMLInputElement>;
    isRequired?: boolean;
    showRequiredAsterisk?: boolean;
    truthyVal?: any;
    falsyVal?: any;
    noLabel?: boolean;
    supplierModel?: ISupplierModel;
    isSupplierVendorOverride?: boolean;
    mutedTextOnDisabled?: boolean;
    labelOnLeft?: boolean;
};

export const OwCheckbox = (props: Props) => {
    const skipTranslate = props.skipTranslate || false;

    const fn = (e: any) => {
        if (!_.isNil(props.truthyVal) && !_.isNil(props.falsyVal)) {
            const customE = {
                target: {
                    type: "input",
                    name: e.target.name,
                },
            } as React.ChangeEvent<HTMLInputElement>;

            if (e.target.checked) {
                customE.target.value = props.truthyVal;
            } else {
                customE.target.value = props.falsyVal;
            }

            props.fn(customE);
        } else {
            props.fn(e);
        }
    };

    let label: any = props.label;

    if (props.isSupplierVendorOverride && !_.isNil(props.supplierModel)) {
        if (!_.isNil(props.supplierModel.vendor_name_override)) {
            label = label.replace(/vendor/g, props.supplierModel.vendor_name_override);
        }
    }

    if (!skipTranslate && label) {
        label = <FormattedMessage id={label} defaultMessage={`_${label}_`} description={props.description} />;
    }

    let checked = props.checked;

    if (_.isNil(checked)) {
        checked = false;
    }

    // console.log(`checkbox ${props.name} checked: `, checked, props.checked);

    let cursor = "pointer";

    if (props.disabled) {
        cursor = "not-allowed";
    }

    const checkbox = (
        <input
            data-testid={"checkbox"}
            type={"checkbox"}
            className={(props.labelOnLeft ? " ms-2 " : "") + (!props.noLabel ? " me-2 " : "") + " pointer " + (props.className || "")}
            checked={checked}
            name={props.name}
            ref={props.ref}
            disabled={props.disabled}
            onChange={fn}
            required={props.isRequired}
        />
    );

    if (props.noLabel) {
        return checkbox;
    } else {
        return (
            <label
                data-testid={"checkbox-label"}
                className={
                    (props.mutedTextOnDisabled && props.disabled ? "text-muted" : "") + ` ${cursor} mb-0 ` + (props.labelClassName || "")
                }>
                {props.labelOnLeft && props.isRequired && props.showRequiredAsterisk ? <span className={"text-danger me-1"}>*</span> : null}
                {props.labelOnLeft ? label : null}
                {checkbox}
                {!props.labelOnLeft && props.isRequired && props.showRequiredAsterisk ? (
                    <span className={"text-danger me-1"}>*</span>
                ) : null}
                {props.labelOnLeft ? null : label}
            </label>
        );
    }
};

export default OwCheckbox;
